export default {
  DRAFT: 1,
  ACTIVE: 2,
  INACTIVE: 3,
};
